import InvitationStatusGridRecord from "../InvitationStatus/Model/InvitationStatusGridRecord"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function GetInvitationStatus(url: string) {
    const requestBody = JSON.stringify({ URL: url })
    return ObservableFromFetch<InvitationStatusGridRecord>("FFOrderClinicStatus/GetInvitationStatus", requestBody)
}

export function GetInvitationAttempts(url: string) {
  const requestBody: string = new URLSearchParams({
    url: url
  }).toString()

  return ObservableFromFetch<number>("FFOrderClinicStatus/GetInvitationAttempts?" + requestBody)
}